import * as React from "react";
import type { SVGProps } from "react";

interface SubstituteInProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SubstituteIn = ({ cancelled = false, ...props }: SubstituteInProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M19.73 2.3a2 2 0 0 1 2 2v10.44c0 1.782-2.154 2.675-3.414 1.415l-1.435-1.436-6.916 6.924a2 2 0 0 1-2.834-.003l-4.75-4.78a2 2 0 0 1 .008-2.828l6.92-6.884-1.432-1.432c-1.26-1.26-.368-3.414 1.414-3.414z"
      />
      <path
        fill="#3A1919"
        d="M19.73 3a1.3 1.3 0 0 1 1.3 1.3v10.44c0 1.159-1.4 1.739-2.219.92l-1.93-1.931-7.411 7.42a1.3 1.3 0 0 1-1.842-.003l-4.75-4.78a1.3 1.3 0 0 1 .005-1.838l7.417-7.38-1.928-1.927C7.553 4.402 8.133 3 9.292 3z"
      />
      <path
        fill="#60B100"
        d="M19.73 4.3v10.44l-2.39-2.39a.65.65 0 0 0-.92 0l-7.87 7.88-4.75-4.78 7.88-7.84a.65.65 0 0 0 0-.92L9.291 4.302l10.44-.002Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SubstituteIn;
